import { observable, action } from 'mobx';

export default class FilterStore {
  @observable showOnLeave = true
  @observable settingsIsOpen = false

  @action
  toggleModal(force) {
    if (force) {
      this.settingsIsOpen = force;
      return;
    }

    this.settingsIsOpen = !this.settingsIsOpen;
  }

  @action
  toggleOnLeave(state) {
    this.showOnLeave = state;
  }
}



// WEBPACK FOOTER //
// ./src/store/filterStore.js